import { render, staticRenderFns } from "./Shuttle.vue?vue&type=template&id=e9840b32"
import script from "./Shuttle.vue?vue&type=script&lang=js"
export * from "./Shuttle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports